import type React from 'react';
import { useTranslation } from 'react-i18next';
import type { ProductTypeCoveragePayload } from '@/types/app';
import { SupportedProductType } from '@/types/app';
import Insurance from '../Insurance';

const PRODUCT_TYPE = SupportedProductType.SICK_LEAVE_LONG_TERM_WIA_EXCESS;
const APPLICATION_FIELD = 'selected_wia_excess_quote_id' as const;

/**
 * The backend pins dekkingspercentage to '70' for WIA Excedent
 * (enforced via _CoverageInternalWithFixedDefaults on MV755WiaExcessInternal).
 * The 75 and 80 options are no longer available.
 */
const FIXED_DEKKINGSPERCENTAGE = '70';

const buildCoverage = (): ProductTypeCoveragePayload => ({
	sick_leave_long_term_wia_excess: { dekkingspercentage: FIXED_DEKKINGSPERCENTAGE }
});

interface WiaExcessProps {
	id: string;
	isSaving?: boolean;
	setIsSaving?: (saving: boolean) => void;
	onConfirm?: () => void;
	onBack?: () => void;
	onLoadingChange?: (isLoading: boolean) => void;
	onItemCountChange?: (itemCount: number) => void;
	showNavigation?: boolean;
	desktopVisibleCards?: number;
}

const WiaExcess = ({
	id,
	isSaving = false,
	setIsSaving = () => {},
	onConfirm = () => {},
	onBack = () => {},
	onLoadingChange = () => {},
	onItemCountChange = () => {},
	showNavigation = true,
	desktopVisibleCards
}: WiaExcessProps): React.JSX.Element => {
	const { t } = useTranslation();

	return (
		<Insurance
			id={id}
			productType={PRODUCT_TYPE}
			applicationField={APPLICATION_FIELD}
			carouselKeyPrefix="wia-excess"
			sectionTranslationKey="productSelection.wiaExcess"
			productName={t('productPackage.products.wiaExcess')}
			logLabel="WIA Excedent"
			initialCoverage={buildCoverage()}
			isSaving={isSaving}
			setIsSaving={setIsSaving}
			onConfirm={onConfirm}
			onBack={onBack}
			onLoadingChange={onLoadingChange}
			onItemCountChange={onItemCountChange}
			showNavigation={showNavigation}
			desktopVisibleCards={desktopVisibleCards}
		/>
	);
};

export default WiaExcess;
